<div class="page-wrapper">
  @if (isLoaded) {
    <i-navbar [config]="navbarConfig" [autoCollapse]="false" [collapsable]="true">
      <main>
        <router-outlet></router-outlet>
      </main>
    </i-navbar>
  }
</div>
